import React, { Component } from 'react';
import cx from 'classnames';
import { Field, reduxForm } from 'redux-form';
import Header from '../scripts/components/global/header';
import Footer from '../scripts/components/global/footer';
import TranslatedCopy from '../scripts/intl/translated-copy';
import Pictogram from '../scripts/components/global/pictogram';
import FormInputText from '../scripts/components/global/form-input-text';
import { retrieveCountriesFromCMS } from '../redux/actions/countries';
import { connect } from 'react-redux';
import Btn from '../scripts/components/global/button';
import KeyMap from '../scripts/utilities/keymap';
import { Home, HomeE4 } from '../routing/urls';
import {
  lastName,
  ticketNumber,
} from '../scripts/validation/validation';
import moment from 'moment';
import 'moment/locale/es';

const mapStateToProps = state => {
  return ({
    contentForm: state.form['PnrForm'],
    country: state.LanguageBundle.country,
    countryContentCMS: state.Countries.countryContent,
    language: state.Manage.language,
  });
};

class PnrForm extends Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    const {
      country,
      dispatch,
      language,
    } = this.props;

    moment.locale(language);
    localStorage.removeItem('restartTime');

    if (country !== '' && language !== '') {
      const hostname = window.location.hostname;
      dispatch(retrieveCountriesFromCMS(language));

      if (hostname !== 'localhost') {
        return window.location.href = HomeE4(language, country);
      }
    }
  }

  render() {
    const {
      contentForm,
      country,
      language,
    } = this.props;

    const className = cx({
      'PNRLookupWrapper-noLogin': true,
      'PNRLookupWrapper': false,
    });
    const errorMessagelastName = (contentForm && contentForm.syncErrors && contentForm.syncErrors.lastName) ? contentForm.syncErrors.lastName : '';
    const errorMessageticketNumber = (contentForm && contentForm.syncErrors && contentForm.syncErrors.ticketNumber) ? contentForm.syncErrors.ticketNumber : '';

    return (
      <div className='Content'>
        <div className='PNRLookup'>
          <Header
            country={ country }
            language={ language }
            showInformation={ false } />
          <section className='PNRLookupHeader'>
            <Pictogram
              className='PNRLookupHeader-icon'
              id='plane' />
            <div className='PNRLookupHeader-content'>
              <TranslatedCopy
                className='PNRLookupHeader-contentTitle'
                copyID='CC_TITLE'
                tagName='h2' />
            </div>
          </section>
          <div className='PNRLookup'>
            <div className={ className }>
              <div
                className='PNRLookupForm'>
                <div className='PNRLookupForm-section'>
                  <div onKeyDown={ (e) => this.onEnterClick(e) }>
                    <Field
                      className='PNRLookupForm-formInput PNRLookupForm-formInput--ticketNumber'
                      component={ FormInputText }
                      errorClassName={ 'PnrInput-error' }
                      errorMessageData={ errorMessageticketNumber }
                      isRequired={ true }
                      labelCopyID='CHECK_IN_RESERVATION_TICKET_NUMBER'
                      name='ticketNumber'
                      validate={ ticketNumber }
                    />
                  </div>
                  <div onKeyDown={ (e) => this.onEnterClick(e) }>
                    <Field
                      className='PNRLookupForm-formInput PNRLookupForm-formInput--ticketNumber'
                      component={ FormInputText }
                      errorClassName={ 'PnrInput-error' }
                      errorMessageData={ errorMessagelastName }
                      isRequired={ true }
                      labelCopyID='PAX_LAST_NAME'
                      name='lastName'
                      validate={ lastName }
                    />
                  </div>
                </div>
                <div className='Form-submit PNRLookupForm-submit'>
                  { this.renderSubmitButton() }
                </div>
              </div>
            </div>
          </div>
          <p className='PNRLookup-footer-noLogin u-textSmall'>¿Tienes problemas para iniciar sesión? <a href='https://booking.aeromexico.com/SSW2010/D5DE/myb.html' target='_blank'
            rel='noopener noreferrer'>
            Da clic aquí
          </a></p>
        </div>
        <Footer
          country={ country }
          language={ language } />
      </div>
    );
  }

  renderSubmitButton() {
    const classes = cx({
      'Form-submit': true,
      'PNRLookupForm-submit': true,
      'Btn Btn--filledRed': true,
    });

    return (
      <Btn
        className={ classes }
        onBtnClick={ (e) => this.handleSubmit(e) }
        copy='CHECK_IN_FIND_RESERVATION' />
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    const { contentForm: { values: { lastName, ticketNumber } }, country, language } = this.props;
    localStorage.setItem('lastName', lastName);
    localStorage.setItem('ticketNumber', ticketNumber);

    return window.location.href = `${ Home(language, country) }?last-name=${ lastName }&pnr=${ ticketNumber }`;
  }

  onEnterClick = (e) => {
    if (e.keyCode === KeyMap.ENTER || e.keyCode === KeyMap.RETURN) {
      this.handleSubmit(e);
    }
  }
}

PnrForm = reduxForm({
  form: 'PnrForm',
  onSubmit: (e) => this.handleSubmit(e),
})(PnrForm);

PnrForm = connect(mapStateToProps)(PnrForm);

export default PnrForm;
